import { ChangeDetectionStrategy, Component, EventEmitter, Output, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cosmos-sidebar-menu-item',
  templateUrl: './sidebar-menu-item.component.html',
  styleUrls: ['./sidebar-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, TranslatePipe]
})
export class SidebarMenuItemComponent {
  public readonly header = input<string>(undefined);

  public readonly isContentVisible = input(false);

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public toggle = new EventEmitter();
}
